/*
 * Product rating (stars + review count) for:
 *   - the product page "Rating and stock" block  [data-pi-rating]
 *   - product cards                              [data-pi-card-rating]
 *
 * Source: get_reviews.php. It already merges the Trustpilot reviews with the
 * "Write a review" form reviews (rSource) and returns the totals:
 *   { "reviews_counts": 53, "average_star": 3.4, "reviews": [...] }
 * Those totals are used as they are. Only if get_reviews.php fails are the
 * Trustpilot reviews loaded directly and counted here.
 *
 * Loaded once from theme.liquid. A MutationObserver picks up ratings inserted later
 * (related products, recently viewed, collection filters, variant change), because
 * inline <script> tags in HTML inserted with innerHTML never run.
 */
(function () {
  if (window.ReviewRating) return;

  /* Set in theme.liquid from the "Trustpilot reviews" theme settings */
  var config = window.TrustpilotConfig || {};
  var API_KEY = config.apiKey;
  var BUID = config.buid || "5c2e4995cccdb1000183931a";
  // var STORE_ENDPOINT = 'https://dddemo.net/php/2026/shopify_app/dev/mrsupplement/get_reviews.php';
  var STORE_ENDPOINT =
    "https://ab.mrsupplement.com.au/reviews/get?shop=mr-supplement-2.myshopify.com";
  /* Safety cap on Trustpilot pages (100 reviews per page) */
  var TP_MAX_PAGES = 20;

  /* One request per product, shared by the product page and every card */
  var cache = {};

  function number(value) {
    if (value === null || value === undefined || value === "") return 0;
    var n = Number(value);
    return isNaN(n) ? 0 : n;
  }

  /* ── Trustpilot: load every page and collect the stars ── */
  function loadTrustpilot(productUrl, done) {
    if (!productUrl) return done([]);

    var stars = [];
    var pages = 0;

    function load(url) {
      pages++;

      fetch(url, { headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (data) {
          var reviews = data.productReviews || data.reviews || [];

          reviews.forEach(function (review) {
            stars.push(number(review.stars) || 5);
          });

          var next = null;
          (data.links || []).forEach(function (link) {
            if (!next && link.rel === "next-page" && link.href) {
              next =
                link.href.indexOf("http") === 0
                  ? link.href
                  : "https://api.trustpilot.com" + link.href;
            }
          });

          if (next && reviews.length && pages < TP_MAX_PAGES) {
            if (next.indexOf("apikey=") === -1)
              next += "&apikey=" + encodeURIComponent(API_KEY);
            load(next);
            return;
          }

          done(stars);
        })
        .catch(function (error) {
          console.error("[review-rating] Trustpilot API failed:", error);
          done(stars);
        });
    }

    load(
      "https://api.trustpilot.com/v1/product-reviews/business-units/" +
        encodeURIComponent(BUID) +
        "/reviews?productUrl=" +
        encodeURIComponent(productUrl) +
        "&perPage=100&apikey=" +
        encodeURIComponent(API_KEY),
    );
  }

  /* ── Store reviews: same response handling as the "Trustpilot reviews static" section ── */
  function extractList(data) {
    if (Array.isArray(data)) return data;
    if (!data || typeof data !== "object") return [];

    var keys = ["reviews", "data", "result", "results", "items"];
    for (var i = 0; i < keys.length; i++) {
      var v = data[keys[i]];
      if (Array.isArray(v)) return v;
      if (v && typeof v === "object") {
        var inner = extractList(v);
        if (inner.length) return inner;
      }
    }
    return [];
  }

  function storeRating(r) {
    var names = [
      "rPoints",
      "rating",
      "stars",
      "rRating",
      "rStars",
      "rStar",
      "star",
      "star_rating",
      "review_rating",
      "rating_value",
      "score",
    ];
    for (var i = 0; i < names.length; i++) {
      var n = parseFloat(r[names[i]]);
      if (!isNaN(n)) return n;
    }
    for (var key in r) {
      if (!/star|rating/i.test(key)) continue;
      var m = parseFloat(r[key]);
      if (m >= 1 && m <= 5) return m;
    }
    return 5;
  }

  function hasContent(r) {
    var names = ["rContent", "review", "content", "text", "body"];
    for (var i = 0; i < names.length; i++) {
      if (r[names[i]] != null && String(r[names[i]]).trim() !== "") return true;
    }
    return false;
  }

  /* Calls done({ average, count }), or done(null) when the request fails */
  function loadStore(productId, done) {
    if (!productId) return done(null);
    console.log("productId", productId);
    /* Simple POST (no custom headers), so no CORS preflight */
    fetch(STORE_ENDPOINT + "&product_id=" + encodeURIComponent(productId), {
      method: "POST",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        console.log("response.status", response.status);
        return response.json();
      })
      .then(function (data) {
        console.log(
          "DD",
          STORE_ENDPOINT + "&product_id=" + encodeURIComponent(productId),
        );
        var count = number(data && data.reviews_counts);
        console.log("count", count);
        var average = number(data && data.average_star);
        console.log("average", average);
        /* Older response without totals: count the review list */
        if (!count) {
          var stars = extractList(data).filter(hasContent).map(storeRating);
          count = stars.length;
          average = count ? sum(stars) / count : 0;
        }

        done({ average: average, count: count });
      })
      .catch(function (error) {
        console.error("[review-rating] get_reviews.php failed:", error);
        done(null);
      });
  }

  function sum(stars) {
    var total = 0;
    stars.forEach(function (s) {
      total += Math.min(5, Math.max(1, s));
    });
    return total;
  }

  /* A product with no reviews still publishes { average: 0, count: 0 }: cards show empty stars and "0 Reviews" */
  function publish(entry, data) {
    if (!data) return;

    var count = number(data.count);
    entry.data = {
      average: count ? Math.min(5, number(data.average)) : 0,
      count: count,
    };
    entry.subs.forEach(function (callback) {
      callback(entry.data);
    });
  }

  /* Calls callback({ average, count }) once the reviews for this product have loaded */
  function get(productId, productUrl, callback) {
    productUrl = (productUrl || "").trim().replace(/\/+$/, "");
    productId = String(productId || "").trim();

    var key = productId || productUrl;
    if (!key) return;

    var entry = cache[key];

    if (!entry) {
      entry = cache[key] = { subs: [], data: null };

      loadStore(productId, function (data) {
        if (data) {
          publish(entry, data);
          return;
        }

        /* get_reviews.php unavailable: fall back to Trustpilot only */
        loadTrustpilot(productUrl, function (stars) {
          publish(entry, {
            average: stars.length ? sum(stars) / stars.length : 0,
            count: stars.length,
          });
        });
      });
    }

    entry.subs.push(callback);
    if (entry.data) callback(entry.data);
  }

  /*
   * Whole stars + a half star when the average has a decimal (4.3 -> 4 full + 1 half).
   * Rounded to one decimal first, so 4.97 counts as 5.
   */
  function starFill(el, prefix, average) {
    var value = Math.round(Math.min(5, Math.max(0, average)) * 10) / 10;
    var full = Math.floor(value);
    var half = value > full ? 1 : 0;

    el.style.setProperty(prefix + "-full", full);
    el.style.setProperty(prefix + "-half", half);
  }

  function scrollToReviews() {
    var target = document.getElementById("trustpilot-reviews");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ── Product page block ── */
  function renderProduct(root, data) {
    var reviewsEl = root.querySelector("[data-pi-reviews]");
    var starsEl = root.querySelector("[data-pi-stars]");
    var countEl = root.querySelector("[data-pi-count]");
    var countSrEl = root.querySelector("[data-pi-count-sr]");
    var dividerEl = root.querySelector("[data-pi-divider]");

    if (!reviewsEl || !starsEl) return;

    var average = Math.min(5, number(data.average));
    var count = number(data.count);
    /* Product page keeps the rating hidden until there is at least one review */
    if (!count) return;
    var label = root.getAttribute("data-reviews-label") || "";
    var totalLabel = root.getAttribute("data-total-label") || "reviews";

    starFill(starsEl, "--pi-rating", average);
    reviewsEl.setAttribute(
      "aria-label",
      "Rated " + average.toFixed(1) + " out of 5 stars",
    );

    if (countEl)
      countEl.textContent = "(" + count + (label ? " " + label : "") + ")";
    if (countSrEl) countSrEl.textContent = count + " " + totalLabel;

    reviewsEl.style.display = "";
    if (dividerEl) dividerEl.style.display = "";
  }

  /* ── Product card ── */
  function renderCard(card, data) {
    var starsEl = card.querySelector("[data-pi-card-stars]");
    var countEl = card.querySelector("[data-pi-card-count]");
    var countSrEl = card.querySelector("[data-pi-card-count-sr]");

    if (!starsEl || !countEl) return;

    var average = Math.min(5, number(data.average));
    var count = number(data.count);
    var text = count + (count === 1 ? " Review" : " Reviews");

    starFill(starsEl, "--mrs-card-rating", average);
    card.setAttribute(
      "aria-label",
      "Rated " + average.toFixed(1) + " out of 5 stars, " + text,
    );
    countEl.textContent = text;
    if (countSrEl) countSrEl.textContent = text;

    var sepEl = card.parentNode
      ? card.parentNode.querySelector("[data-pi-card-sep]")
      : null;
    card.style.display = "";
    if (sepEl) sepEl.style.display = "";
  }

  /*
   * Elements already claimed. A WeakSet, not a marker attribute: collection-pins.js re-orders
   * the grid with cloneNode copies, and a copied attribute made the visible copy look done
   * while the review data filled the removed original, so the card never showed its rating.
   */
  var claimed = new WeakSet();

  function claim(el) {
    if (claimed.has(el)) return false;
    claimed.add(el);
    return true;
  }

  function init(scope) {
    scope = scope || document;

    scope.querySelectorAll("[data-pi-rating]").forEach(function (root) {
      if (!claim(root)) return;

      get(
        root.getAttribute("data-product-id"),
        root.getAttribute("data-product-url"),
        function (data) {
          renderProduct(root, data);
        },
      );

      var reviewsEl = root.querySelector("[data-pi-reviews]");
      if (reviewsEl) reviewsEl.addEventListener("click", scrollToReviews);
    });

    scope.querySelectorAll("[data-pi-card-rating]").forEach(function (card) {
      if (!claim(card)) return;

      get(
        card.getAttribute("data-product-id"),
        card.getAttribute("data-product-url"),
        function (data) {
          renderCard(card, data);
        },
      );
    });
  }

  /* A review was just submitted through the form: include it right away */
  document.addEventListener("store-review:submitted", function (event) {
    var d = event.detail || {};
    if (!d.review || !String(d.review).trim()) return;

    var entry = cache[String(d.product_id || "").trim()];
    if (!entry || !entry.data) return;

    var rating = Math.min(5, Math.max(1, parseFloat(d.rating) || 5));
    var count = entry.data.count;

    publish(entry, {
      average: (entry.data.average * count + rating) / (count + 1),
      count: count + 1,
    });
  });

  window.ReviewRating = { get: get, init: init };

  function start() {
    init(document);

    /* At most one scan per frame, however many nodes were added */
    var queued = false;

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        init(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
